<template>
    <v-container class="registerUser fill-height" fluid>
        <v-row class="registerUser__register" align="center" justify="center">
            <v-col cols="12" md="8">
                <ReVerifyEmail />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import ReVerifyEmail from "../../../components/Applicants/Authentication/ReVerifyEmail.vue"

export default {
    components: {
        ReVerifyEmail
    }
}
</script>

<style scoped>
.registerUser {
    background-image: url('../../../assets/background/unauthenticated_cover.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
}
</style>